import { render, staticRenderFns } from "./template.vue?vue&type=template&id=c0466728&scoped=true"
var script = {}
import style0 from "./template.vue?vue&type=style&index=0&id=c0466728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0466728",
  null
  
)

export default component.exports